import { render } from "./selectLessonFile.vue?vue&type=template&id=745dde2c"
import script from "./selectLessonFile.vue?vue&type=script&lang=js"
export * from "./selectLessonFile.vue?vue&type=script&lang=js"

import "./selectLessonFile.vue?vue&type=style&index=0&id=745dde2c&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__